const buildRadarOptions = ({
  categories,
  yaxis = {},
  tooltipFormatter = (val) => `${val}`,
  dataLabelsFormatter,
  size = 140,
} = {}) => {
  const labelColor = "#374151";
  const xaxisLabelColors = Array.isArray(categories)
    ? categories.map(() => labelColor)
    : labelColor;
  const defaultLabels = {
    formatter: (val) => Math.round(val),
    style: { colors: labelColor },
  };
  const resolvedYAxis = {
    show: false,
    ...yaxis,
    labels: { ...defaultLabels, ...(yaxis?.labels ?? {}) },
  };

  return {
    chart: {
      type: "radar",
      toolbar: { show: false },
      foreColor: labelColor,
      animations: { enabled: false },
    },
    xaxis: {
      categories,
      labels: { show: true, style: { colors: xaxisLabelColors } },
    },
    yaxis: resolvedYAxis,
    stroke: { width: 2 },
    fill: { opacity: 0.2 },
    markers: { size: 4 },
    plotOptions: {
      radar: {
        size,
        polygons: {
          strokeColors: "#e5e7eb",
          connectorColors: "#e5e7eb",
          fill: { colors: ["#ffffff", "#f9fafb"] },
        },
      },
    },
    tooltip: {
      y: { formatter: tooltipFormatter },
    },
    dataLabels: {
      enabled: true,
      ...(typeof dataLabelsFormatter === "function"
        ? { formatter: dataLabelsFormatter }
        : {}),
      background: {
        enabled: true,
        borderRadius: 2,
      },
    },
  };
};

const buildStackedBarOptions = ({
  categories,
  colors,
  horizontal = false,
  columnWidth,
  fillOpacity,
  dataLabels = false,
  legendPosition = "bottom",
  stackType,
  tooltipFormatter,
} = {}) => {
  const options = {
    chart: { type: "bar", stacked: true, toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal,
        borderRadius: 4,
        ...(columnWidth ? { columnWidth } : {}),
      },
    },
    xaxis: { categories },
    legend: { position: legendPosition },
    dataLabels: { enabled: dataLabels },
    colors,
  };

  if (stackType) {
    options.chart.stackType = stackType;
  }

  if (Number.isFinite(fillOpacity)) {
    options.fill = { opacity: fillOpacity };
  }

  if (typeof tooltipFormatter === "function") {
    options.tooltip = { y: { formatter: tooltipFormatter } };
  }

  return options;
};

export { buildRadarOptions, buildStackedBarOptions };
